import React, { useEffect, useState } from "react";
import swal from "@sweetalert/with-react";

import {
  Button,
  Col,
  Form,
  Row,
  Input,
  Label,
  InputGroupAddon,
  FormGroup,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { checkPermission } from "../../../../Helper";
import "./baseForms.css";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import "./myReactSelect.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import tooltipText from "../../ShortCutComponents/tooltipText";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import PurchasereceiptModal from "./purchasereceiptModal";

export default function UserGroupForm(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  const [loadingResponce, setLoadingResponce] = useState(true);
  const [table, setTable] = useState([]);
  const [data, setData] = useState({
    userModule: "",
    branch: null,
    showModalAddNew: true,
  });

  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    let uomId = data.uom?.id;
    if (uomId) props.toggle(uomId);
    else props.toggle();
  };
  const onCountChange = (newCount) => {
    props.onCountChange(newCount);
  };

  const inputEvent = (e, pValue) => {
    // console.log(e.target.value);
    if (pValue === "branch") {
      setData({
        ...data,
        branch: e,
      });
    } else {
      const value = e.target.value;
      const name = e.target.name;
      setData({
        ...data,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    console.log("props--", props);
    const id = props?.purchaseId;
    if (id) {
      getDataWithId(id);
    }
    getPurchRecData(id);
  }, []);

  const getPurchRecData = (id) => {
    axios
      .post(
        `${baseurl}/masterData/getPurchRecData`,

        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let responseData = response.data.data;

        setTable(responseData);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoadingResponce(false);
      });
  };
  const getDataWithId = (id) => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/userModule/getUserGroups`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data;
        const branch = {
          id: response[0].sub_inv_id,
          label: response[0].sub_inv_desc,
        };
        setData({
          ...data,
          userModule: response[0].usergroup_desc,
          branch,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponce(false);
      });
  };

  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
    setData({
      ...data,
      userIp: res.ip,
      userCountry: res.country,
    });
  };
  const handleSubmitAddItem = async (event) => {
    // return;
    event.preventDefault();
    console.warn(data);
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");
    const newRecord = { ...data };
    console.log(newRecord);
    console.log(companyId);
    console.log(data.defaultSalesTax);
    // return;
    let { userIp, userCountry } = await getUserIp();
    if (1 == 1) {
      if (props?.EditData?.usergroup_id > -1) {
        let id = props.EditData.usergroup_id;
        axios
          .post(
            `${baseurl}/userModule/getUpdateUserGroup`,
            {
              id,

              companyId,
              userGroup: data.userModule,
              branch: data.branch?.id,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )

          .then(function (response) {
            setLoadingResponce(false);
            console.log(response.data);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Success!",
                text: "UserGroup Updated!",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
            // return;
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        axios
          .post(
            `${baseurl}/userModule/addUserGroup`,
            {
              companyId,
              userModule: data.userModule,
              branch: data.branch?.id,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "UserGroup Added",
                icon: "success",
              }).then((value) => {
                onCountChange(1);
                toggleAddNew();
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      setLoadingResponce(false);
    }
  };

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "All",
        value: table.OverViewDataTable?.length,
      },
    ],
  };
  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div>
          <Modal
            show={data.showModalAddNew}
            size="md"
            onHide={toggleAddNew}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={toggleAddNew}
              className=" Creative-Invoice-header-styling"
            >
              {console.log("props.EditData", props)}
              <strong>
                <h4> Purchase Receipt Modal </h4>
              </strong>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="row">
                    <div className="col-md-12">
                      {/* <Form name="simpleForm" onSubmit={handleSubmitAddItem}> */}
                      <div translate="no" className="">
                        <BootstrapTable
                          data={table}
                          striped
                          pagination
                          hover
                          search
                          tableHeaderClass="rpr_header"
                          tableBodyClass="rpr_body"
                          containerClass="rpr_container"
                          options={options}
                        >
                          <TableHeaderColumn
                            dataField="ITEM_DESC"
                            dataAlign="center"
                            width="25%"
                            row="0"
                            rowSpan="2"
                            dataSort={true}
                            isKey={true}
                          >
                            Item
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            // dataField="description"
                            dataAlign="center"
                            // width="25%"
                            // isKey={true}
                            row="0"
                            colSpan="2"
                          >
                            Quantities
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="pending_qty"
                            dataAlign="left"
                            width="10%"
                            // isKey={true}
                            className="rpr_header"
                            row="1"
                          >
                            Balance
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="PRIMARY_QTY"
                            dataAlign="left"
                            width="10%"
                            className="rpr_header"
                            row="1"
                          >
                            Received
                          </TableHeaderColumn>

                          {/* <TableHeaderColumn
                              dataAlign="center"
                              dataField="dept_id"
                              row="0"
                              rowSpan="2"
                              width="10%"
                              //    dataFormat={orderDetHandler}
                              className="rpr_header"
                            >
                              Action
                            </TableHeaderColumn> */}
                        </BootstrapTable>
                      </div>
                      <hr
                        style={{
                          border: "1px solid ",
                          marginBottom: "3vh",
                          marginTop: "3vh",
                          borderColor: "E4E5E6",
                        }}
                      />
                      {/* <FormGroup>
                          <Button
                            // onClick={handleSubmitAddItem}
                            // type="submit"
                            className="mr-1 invoiceSubmitButton "
                          >
                            {props?.EditData?.usergroup_id > -1
                              ? "Update"
                              : "Save"}{" "}
                            Changes
                          </Button>
                          <Button
                            onClick={() => toggleAddNew()}
                            className="mr-1"
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </FormGroup> */}
                      {/* </Form> */}
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
